import React from "react";

const WhoIsWayPickForSection = () => {
  return (
    <>
      {/* Use Cases */}
      <section className="max-w-5xl mx-auto pt-12 pb-12  space-y-12 px-4 text-gray-800">
        <h2 className="text-3xl font-semibold text-center">Who is WayPick for?</h2>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-6 shadow-sm">
            <h3 className="text-xl font-semibold mb-2">🧳 Relaxed Resort Tourist</h3>
            <p>
              Tired of lying on the beach? Don’t know what to explore nearby?
              <strong> WayPick suggests exciting spots</strong> outside your hotel - nature, culture, food - and builds a
              looped route that fits your time and mood.
            </p>
            <p className="italic text-sm text-gray-600 mt-2">No research. No stress.</p>
          </div>
          <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6 shadow-sm">
            <h3 className="text-xl font-semibold mb-2">🚗 Independent Explorer</h3>
            <p>
              Spending hours on Google Maps and blogs to plan your next stop?
              <strong> WayPick creates multi-day itineraries in seconds</strong>, whether you’re walking or driving.
            </p>
            <p className="mt-2">Even while moving between cities, discover <strong>hidden sights</strong> along the way
              that you'd otherwise miss.</p>
          </div>
        </div>
      </section>
    </>
  );
}

export default WhoIsWayPickForSection;